
import { SxProps, useTheme, Typography, Button } from "@mui/material";
import { styled } from '@mui/system';
import { StyleguideSavioColors, StyleguideSavioFonts } from "../../../site/configuration/themeSettings";



interface MyStyledButtonContainerProps {
  buttonPosition?: string;
  buttonLocation?: number;
  isToExpand: string | boolean;
}

export const ButtonContainer = styled("div", { label: "buttonContainerOnScreenHelp-Div" })<MyStyledButtonContainerProps>
  (({  buttonPosition, buttonLocation ,isToExpand, theme }) => ({
   
    position: "fixed",
    width: "100%",
    zIndex: 10000001,

    bottom:   ( buttonPosition === undefined ||buttonPosition === "bottom") 
            ? (buttonLocation !== undefined)
                ? (buttonLocation !== 0)
                    ? buttonLocation
                    : isToExpand ? 15 : 0
                :isToExpand
                  ? 15
                  : 0
            : "unset"
            ,
    top:   ( buttonPosition === undefined ||buttonPosition === "bottom") 
            ? "unset"
            : (buttonLocation !== undefined)
                ? buttonLocation 
                : 0 

}));

export const ButtonContainerInside = styled("div", { label: "buttonContainerInsideOnScreenHelp-Div" })
  (({   theme }) => ({
       color: "#FFFFFF",
       
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    maxWidth: 1700,
    marginLeft: "auto",
    marginRight: "auto",
    position: "relative",
    width: "100%",

 
   

}));


export const StyledTypography = styled(Typography, { label: "buttonContainerTypografyTextOnScreenHelp-root" })
  (({  theme }) => ({
    borderRadius: 100,
    maxWidth: 245,
    alignSelf: "center",
    color: StyleguideSavioColors.blue,
    backgroundColor: "rgba(255, 255, 255, 1)",
    //border: "2px solid "+StyleguideSavioColors.blue,
    padding: "10px",
    margin: "10px",
    minWidth: "100px",
    height: "55px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontSize: 13,
    textTransform: "uppercase",
    fontWeight: StyleguideSavioFonts.bold,

    
    "& > div": {
      lineHeight: "15px",
    },
    "&:hover": {},
    cursor: "pointer" 
  }));



export const useClasses = () => {
    const theme = useTheme();

    const classes = {
        ButtonContainerInside  : {
                 alignSelf: "flex-end"
        }as SxProps
    }
    return classes;

};
